import React, { Component } from "react";
import {
  SelectField,
  MenuItem,
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Dialog,
  TextField,
  IconButton,
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
  Menu,
  CardHeader,
  CardText,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import {
  FormsyRadioGroup,
  FormsyRadio,
  FormsyText,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Dropzone from "react-dropzone";
import ScanSnapOCR from "../../data/images/ScanSnapOCR.png";
import ScanSnapIcon from "../../data/images/ScanSnapIcon.png";

export default class ShowUpload8879s extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "Click to upload file, or drag and drop file",
      open: false,
      file: "",
      response: "",
      resMessage: "",
      isLoading: false,
      fileList: [],
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          maxHeight: "200px",
          border: "3px dashed #ebeff2",
          overflow: "auto",
        },
        activeZone: {
          width: "100%",
          maxHeight: "200px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
          overflow: "auto",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
    };
    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  submitForm(data) {
    var me = this;
    if (this.state.fileList.length > 0) {
      //For multiple file upload - new code
      this.setState({ message: "Uploading File", isLoading: true });
      let formData = new FormData();
      let url = "/api/documentUpload/upload";
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
        },
        body: formData,
      };
      this.state.fileList.map((file) => {
        //For multiple file upload - new code
        if (file.type === "application/pdf") {
          formData.append("files", file);
        }
      });

      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          } else {
            this.setState({
              isLoading: false,
              message: "Internal Server Error",
              response: [],
            });
          }
        })
        .then((json) => {
          me.setState({
            response: [],
            isLoading: false,
            message: json.message,
            resMessage: json.message,
          });
        })
        .catch(function (e) {
          console.log("error", e.message);
          this.setState({ isLoading: false, message: e.message });
        });
    }
  }

  notifyFormError(data) {
    alert("Form error:", JSON.stringify(data, null, 4));
  }

  resetForm() {
    this.setState({
      fileList: [],
      file: "",
      response: "",
      isLoading: false,
      message: "Click to upload file, or drag and drop file",
      resMessage: "",
    });
  }

  onDrop(e) {
    var me = this;
    if (e.length > 0) {
      let fList = [];
      e.forEach(function (fileData, index) {
        if (fileData.type === "application/pdf") {
          fileData["reason"] = "";
          fList.push(fileData);
        } else {
          fileData["reason"] = "Expecting PDF";
          fList.push(fileData);
        }
        if (index == e.length - 1) {
          me.setState({ fileList: fList, message: "" });
        }
      });
    } else {
      this.setState({ message: `Incorrect File Type, expecting PDF` });
    }

    /*if(e[0].type === 'application/pdf') {
  			this.setState({file: e[0]});
  		}
  		else {
  			this.setState({message: `Incorrect File Type, expecting PDF`})
  		}*/
  }

  renderContent() {
    let { response, isLoading, resMessage } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    console.log("fileList---------------", this.state.fileList);

    if (isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={"red"} />
            <h3>{this.state.message}</h3>
          </center>
        </div>
      );
    } else if (!response) {
      return (
        <div style={{ padding: "2rem" }}>
          <Dropzone
            className="rightUploadDiv"
            onDrop={this.onDrop}
            disablePreview={true}
            style={zone}
            activeStyle={activeZone}
          >
            <left style={{ marginLeft: "1rem" }}>
              {this.state.fileList.length > 0 ? (
                this.state.fileList.map((file, index) => {
                  return (
                    <h4 style={{ color: file.reason ? "red" : "#000" }}>
                      {file
                        ? file.reason != ""
                          ? file.name +
                            " is not in PDF format. PDF file is expected."
                          : file.name +
                            " will be submitted for batch processing. A notification will be sent via email once the process is complete."
                        : ""}
                    </h4>
                  );
                })
              ) : (
                <h4>{this.state.message}</h4>
              )}
            </left>
          </Dropzone>
        </div>
      );
    } else {
      return (
        <div style={centerStyle}>
          <h4>Upload Results</h4>
          <p style={{ color: "blue", fontWeight: "bold" }}>{resMessage}</p>
          <Card style={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
            <CardHeader
              title="Troubleshooting"
              // titleStyle={{fontWeight: 'bold', fontSize: '150%'}}
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true} style={{ margin: "0.5em" }}>
              <p>
                1. <strong>Only 8879s should be uploaded in this input!</strong>
              </p>
              <p>
                2. If the table says 'There is no data to display' it means the
                PDF that was uploaded did not contain text with ClientIds and
                tax year.
              </p>
              <p>
                To ensure your scanned documents contain text, open the ScanSnap
                Settings by right-clicking{" "}
                <img
                  src={ScanSnapIcon}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  alt="the icon"
                />{" "}
                in the notification tray and selecting '
                <strong>Scan Button Settings...</strong>', Then configure OCR as
                shown in the image below.
              </p>
              <p>
                <center>
                  <img
                    src={ScanSnapOCR}
                    style={{ maxWidth: "75%", maxHeight: "75%" }}
                    alt="File option -> Select OCR -> ConverToSearchablePDF, OCR Options -> All Pages"
                  />
                </center>
              </p>
            </CardText>
          </Card>
        </div>
      );
    }
  }

  sentFormatter(status) {
    let color;
    if (status === "Ignored Duplicate File") {
      color = "orange";
    } else if (status !== "Success") {
      color = "red";
    }

    return <div style={{ color: color }}>{status}</div>;
  }

  render() {
    let { open } = this.props;
    let { inputHr } = this.state.styles;
    return (
      <div style={{ display: open ? "block" : "none" }}>
        <div className="row" style={{ height: "calc(100vh - 40px)" }}>
          <div className="column d-flex align-items-stretch rightMainDiv">
            {this.renderContent()}
            <div
              style={{
                float: "right",
                marginTop: "1rem",
                position: "absolute",
                right: "30px",
              }}
            >
              <FlatButton
                disabled={this.state.isLoading}
                onClick={this.resetForm.bind(this)}
                className="flatButtonCls"
              >
                Reset
              </FlatButton>
              <FlatButton
                disabled={this.state.isLoading || !!this.state.response}
                type="submit"
                style={{ marginLeft: "2rem" }}
                className="flatButtonCls"
                onClick={this.submitForm}
              >
                Submit
              </FlatButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/ShowUpload8879s.js